import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-10">
            <div className="relative rounded-2xl overflow-hidden h-64 md:h-72 w-full mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Breaking%20news%20concept%20art%20abstract%20dynamic%20composition%20with%20red%20and%20dark%20tones%20newspaper%20texture%20overlay%20modern%20editorial%20design%20minimalist%20clean%20aesthetic%20journalism%20theme%20artistic%20photography%20with%20film%20grain&width=1200&height=500&seq=cta-news-01&orientation=landscape"
                alt="订阅每日爆料"
                title="爆料网 订阅每日爆料"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 leading-snug">
            {t('home:cta.title')}
            <br />
            <span className="italic text-foreground-400">{t('home:cta.titleEmphasis')}</span>
          </h2>
          <p className="text-base text-foreground-600 mb-10">
            {t('home:cta.subtitle')}
          </p>

          <button className="whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-background-50 px-10 py-4 rounded-full text-base font-medium cursor-pointer transition-colors">
            {t('home:cta.button')}
          </button>

          <p className="mt-6 text-xs text-foreground-400">
            {t('home:cta.trust')}
          </p>
        </div>
      </div>
    </section>
  );
}